<template>
  <v-card flat class="pa-0 record-form">
    <div v-if="readonly" class="clinical-readonly">
      <div class="clinical-readonly__grid">
        <div
          v-for="field in readonlyFields"
          :key="field.key"
          v-show="hasReadonlyValue(field.value)"
          class="clinical-readonly__item"
        >
          <p class="clinical-readonly__label">{{ field.label }}</p>
          <p class="clinical-readonly__value">{{ field.value }}</p>
        </div>
      </div>
      <p v-if="!readonlyFields.some(field => hasReadonlyValue(field.value))" class="caption grey--text ma-0">—</p>
    </div>
    <v-row v-else no-gutters>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.notes"
          outlined
          dense
          :label="_getLabel('EVOLUTION_NOTES')"
          rows="3"
        ></v-textarea>
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-2">
        <v-text-field
          v-model.number="localModel.vitalSigns.temperature"
          outlined
          dense
          type="number"
          :label="_getLabel('TEMPERATURE')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" class="px-sm-1">
        <v-text-field
          v-model.number="localModel.vitalSigns.heartRate"
          outlined
          dense
          type="number"
          :label="_getLabel('HEART_RATE')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" class="pl-sm-2">
        <v-text-field
          v-model.number="localModel.vitalSigns.respiratoryRate"
          outlined
          dense
          type="number"
          :label="_getLabel('RESPIRATORY_RATE')"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.medications"
          outlined
          dense
          :label="_getLabel('MEDICATIONS_ADMINISTERED')"
          rows="2"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
/**
 * `vitalSigns` é sempre um objeto próprio do formulário: o backend recusa
 * (HTTP 400) qualquer valor que não seja objeto e o v-model precisa de um
 * destino existente para cada sinal vital.
 */
const buildModel = (value) => ({
  notes: "",
  medications: "",
  ...(value || {}),
  vitalSigns: { ...((value && value.vitalSigns) || {}) },
});

export default {
  name: "EvolutionForm",
  props: {
    value: {
      type: Object,
      default: () => ({ notes: "", vitalSigns: {}, medications: "" }),
      required: false,
    },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      localModel: buildModel(this.value),
    };
  },
  computed: {
    readonlyFields() {
      const vitalSigns = this.localModel.vitalSigns || {};
      return [
        ['notes', 'EVOLUTION_NOTES', this.localModel.notes],
        ['temperature', 'TEMPERATURE', vitalSigns.temperature],
        ['heartRate', 'HEART_RATE', vitalSigns.heartRate],
        ['respiratoryRate', 'RESPIRATORY_RATE', vitalSigns.respiratoryRate],
        ['medications', 'MEDICATIONS_ADMINISTERED', this.localModel.medications],
      ].map(([key, label, value]) => ({ key, label: this._getLabel(label), value }));
    },
  },
  methods: {
    hasReadonlyValue(value) {
      return value !== null && value !== undefined && String(value).trim() !== "";
    },
  },
  watch: {
    value: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.localModel)) {
          this.localModel = buildModel(val);
        }
      },
      deep: true,
    },
    localModel: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.value)) {
          this.$emit("input", val);
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.record-form .v-input { margin-bottom: 8px; }
.clinical-readonly__grid { display: grid; gap: 8px; grid-template-columns: repeat(3, minmax(0, 1fr)); }
.clinical-readonly__item { background: #f5f6fa; border-radius: 8px; min-width: 0; padding: 10px 12px; }
.clinical-readonly__label { color: #667085; font-size: 11px; font-weight: 700; margin: 0 0 4px; }
.clinical-readonly__value { color: #193153; font-size: 14px; line-height: 1.45; margin: 0; overflow-wrap: anywhere; white-space: pre-wrap; }
@media (max-width: 599px) { .clinical-readonly__grid { grid-template-columns: 1fr; } }
</style>
